import { SVGProps, Ref, forwardRef } from 'react';

export const PinCrossedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m19.918 9.841-3.133 3.133-5.768-5.768 3.133-3.132-1.803-1.802L13.619 1l9.375 9.372-1.273 1.272zm-4.584 6.766L21.728 23 23 21.728 2.276 1.004 1.004 2.276l6.38 6.381-.11-.016a6.12 6.12 0 0 0-5.192 1.73L1 11.454l5.138 5.136-5.134 5.132 1.272 1.273L7.41 17.86l5.128 5.126 1.081-1.081a6.12 6.12 0 0 0 1.73-5.19z"
            fill="currentColor"
        />
    </svg>
));
PinCrossedFilledSize24Glyph.displayName = 'PinCrossedFilledSize24Glyph';
